module.exports = __webpack_public_path__ + "static/media/interest.fc2b167e.png";